var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    rx: 74,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3086 80.6797L25.1221 87.5957",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2578 82.543L30.1739 85.7295",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126 43.8096C126 43.8096 119.994 42.0204 118.19 48C119.994 42.0205 114 40.1904 114 40.1904C114 40.1904 120.006 41.9795 121.81 36C120.006 41.9795 126 43.8096 126 43.8096Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6584 83.7189C70.5737 86.6007 86.6283 75.1904 89.5172 58.2333C92.4061 41.2762 81.0355 25.1935 64.1201 22.3117C47.2048 19.4299 31.1502 30.8402 28.2613 47.7973C25.3724 64.7545 36.7431 80.8371 53.6584 83.7189Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3191 93.0527C50.9437 92.7631 49.438 93.5184 48.4824 94.5494C47.5268 95.5804 47.1619 97.1248 47.5551 98.4742C48.4999 101.717 53.1492 103.189 53.2594 106.565C53.331 108.763 51.3576 110.439 49.478 111.58C47.5983 112.722 45.4522 113.89 44.7628 115.978C44.2377 117.568 44.7209 119.333 45.5317 120.799C46.3426 122.265 47.4644 123.535 48.3525 124.955",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6585 83.7177L46.3108 91.9848L57.259 93.85L53.6585 83.7177Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0107 44.5938L51.104 53.1789",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3513 45.8425L43.7661 51.9357",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4316 48.4023L73.5249 56.9875",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7702 49.6472L66.1851 55.7404",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0635 60.2539L66.0927 63.4845",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.781 94.0021C111.749 94.0021 106.048 88.3038 106.048 81.2745C106.048 74.2452 111.749 68.5469 118.781 68.5469C125.812 68.5469 131.513 74.2452 131.513 81.2745C131.513 88.3038 125.812 94.0021 118.781 94.0021Z",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.78 68.5469V94.0021",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.513 81.2734H106.048",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.778 72.2734L127.784 90.273",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.784 72.2734L109.778 90.273",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5699 81.3841L77.5857 92.3957L77.9534 92.135C79.4472 91.0446 81.2142 90.4875 82.981 90.4875C84.736 90.4875 86.4909 91.0327 87.9731 92.1113C90.807 94.1619 94.6133 94.2687 97.5661 92.3839L98.977 91.483C101.835 89.6578 105.499 89.705 108.321 91.5898L108.404 91.6491L118.779 81.2773L106.044 81.3011L66.5699 81.3841Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.071 92.3521L77.353 70.4219H67.0713",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6758 107.426V131.928",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1481 131.93H103.205",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5862 92.3957L92.6216 107.426L108.404 91.649L108.321 91.5898C105.499 89.705 101.835 89.6578 98.9775 91.483L97.5665 92.3838C94.6137 94.2687 90.8074 94.1619 87.9735 92.1112C86.4913 91.0327 84.7364 90.4874 82.9815 90.4874C81.2147 90.4874 79.4477 91.0445 77.9538 92.1349L77.5862 92.3957Z",
    fill: "#CDD0D5",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStates);
export default __webpack_public_path__ + "static/media/EmptyStates.9934e9e4da612c0c55f454f9d544cee6.svg";
export { ForwardRef as ReactComponent };